import React from 'react';
import AppointmentForm from './AppointmentForm';
import './Contact.css';

const Contact = () => {
    return (
        <section id="contact">
            <div className="container">
                <div className="section-title">Kontakt</div>
                <div className="section-subtitle">Skontaktuj się z nami lub wypełnij formularz</div>
                <div className="contact-grid">
                    <div className="contact-info">
                        <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <div>
                                <h4>Adres</h4>
                                <p>ul. Żółkiewskiego 4, 35-203 Rzeszów</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <i className="fas fa-phone-alt"></i>
                            <div>
                                <h4>Telefon</h4>
                                <p><a href="tel:+48888329544">888 329 544</a></p>
                            </div>
                        </div>
                        <div className="info-item">
                            <i className="fab fa-whatsapp"></i>
                            <div>
                                <h4>WhatsApp</h4>
                                <p>888 329 544</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <i className="far fa-clock"></i>
                            <div>
                                <h4>Godziny otwarcia</h4>
                                <p>Pn-Pt: 8:00 - 18:00<br />Sb: 8:00 - 14:00<br />Nd: zamknięte</p>
                            </div>
                        </div>
                        <a href="https://www.google.com/maps/place/Strefa+Nap%C4%99du/@50.0439377,22.0118501,17z/data=!3m1!4b1!4m6!3m5!1s0x473cfb0a5b067467:0x74b40195e81d8c0f!8m2!3d50.0439377!4d22.014425!16s%2Fg%2F11zb5r3jy7?authuser=0&entry=ttu&g_ep=EgoyMDI2MDYxMC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ marginTop: '20px', display: 'inline-block' }}>
                            <i className="fab fa-google"></i> Zobacz na Google Maps
                        </a>
                    </div>
                    <div className="contact-form">
                        <AppointmentForm />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;